import { makeStyles } from "@material-ui/core/styles";

const useFooterStyle = makeStyles(theme => ({
  footer: {
    backgroundColor: "#131313",
    color: "white",
    border: "1px solid #1F1F1F",
    top: 0,
    zIndex: theme.zIndex.drawer + 1,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    columnGap: "20px",
    padding: "20px",
    [theme.breakpoints.down("sm")]: {
      padding: "15px",
    },
  },
  footerContainer: {
    maxWidth: "1180px",
    width: "100%",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
  },
  footerTop: {
    backgroundColor: "#131313",
    color: "white",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    columnGap: "40px",
    paddingBottom: "20px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "20px",
    },
  },
  footerHelpContainer: {
    maxWidth: "1180px",
    width: "100%",
    margin: "0 auto",
    textAlign: "left",
    color: "white",
  },
  footerH: {
    backgroundColor: "#131313",
    color: "white",
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "20px",
    marginTop: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      marginBottom: "20px",
      lineHeight: "1.2",
    },
  },
  footerHWithMargin: {
    backgroundColor: "#131313",
    color: "white",
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "20px",
    marginTop: "20px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      marginTop: 0,
      marginBottom: "20px",
    },
  },
  footerList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    "& li": {
      marginBottom: "12px",
      fontSize: "12px",
      "&:last-child": {
        marginBottom: 0,
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "10px",
        marginBottom: "10px",
      },
    },
  },
  footerSection: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    "&:not(:last-child)": {
      marginRight: "40px",
    },
    [theme.breakpoints.down("sm")]: {
      "&:not(:last-child)": {
        marginRight: 0,
        marginBottom: 0,
      },
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
      gap: "20px",
    },
  },
  contactCcbillBlock: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      flex: 1,
    },
  },
  legalFooterSection: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    width: "430px",
    "&:not(:last-child)": {
      marginRight: "40px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      "&:not(:last-child)": {
        marginRight: 0,
        marginBottom: "20px",
      },
    },
  },
  legalFooterH: {
    backgroundColor: "#131313",
    color: "#FFFFFF",
    fontSize: "18px",
    fontWeight: 700,
    marginBottom: "12px",
    marginTop: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
  legalFooterList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    "& li": {
      marginBottom: "12px",
      fontSize: "16px",
      fontWeight: 400,
      "&:last-child": {
        marginBottom: 0,
      },
      "& a": {
        color: "#FFFFFFCC",
        textDecoration: "none",
        transition: "color 0.2s ease",
        "&:visited": {
          color: "#FFFFFFCC",
        },
        "&:hover, &:focus": {
          color: "#FFFFFF",
          textDecoration: "underline",
        },
        "&:focus-visible": {
          outline: "2px solid #ff69b4",
          outlineOffset: 2,
          borderRadius: 4,
        },
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
        marginBottom: "10px",
        textAlign: "left",
        "& a": {
          textAlign: "left",
        },
      },
    },
  },
  contactUsFooterSection: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    width: "430px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      gap: "20px",
    },
  },
  contactUsBlock: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      flex: 1,
    },
  },
  contactUsFooterList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    "& li": {
      marginBottom: "12px",
      fontSize: "16px",
      "&:last-child": {
        marginBottom: 0,
      },
      "& a": {
        color: "#FFFFFF",
        textDecoration: "none",
        transition: "color 0.2s ease",
        "&:visited": {
          color: "#FFFFFF",
        },
        "&:hover, &:focus": {
          color: "#FFFFFFCC",
          textDecoration: "underline",
        },
        "&:focus-visible": {
          outline: "2px solid #ff69b4",
          outlineOffset: 2,
          borderRadius: 4,
        },
        "& svg": {
          fill: "#FE5A97",
          color: "#FE5A97",
        },
        [theme.breakpoints.down("sm")]: {
          justifyContent: "flex-start",
          "& svg": {
            fill: "#FFFFFF",
            color: "#FFFFFF",
          },
        },
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
        marginBottom: "10px",
        textAlign: "left",
      },
    },
  },
  ccbillFooterList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    "& li": {
      marginBottom: "12px",
      fontSize: "16px",
      "&:last-child": {
        marginBottom: 0,
      },
      "& a": {
        color: "#FFFFFF",
        textDecoration: "none",
        transition: "color 0.2s ease",
        "&:visited": {
          color: "#FFFFFF",
        },
        "&:hover, &:focus": {
          color: "#FFFFFFCC",
          textDecoration: "underline",
        },
        "&:focus-visible": {
          outline: "2px solid #ff69b4",
          outlineOffset: 2,
          borderRadius: 4,
        },
        "& svg": {
          fill: "#FE5A97",
          color: "#FE5A97",
        },
        [theme.breakpoints.down("sm")]: {
          justifyContent: "flex-start",
          "& svg": {
            fill: "#FFFFFF",
            color: "#FFFFFF",
          },
        },
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
        marginBottom: "10px",
        textAlign: "left",
      },
    },
  },
  followUsFooterSection: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    maxWidth: "280px",
    "&:not(:last-child)": {
      marginRight: "40px",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      "&:not(:last-child)": {
        marginRight: 0,
        marginBottom: "20px",
      },
    },
  },
  footerRightRow: {
    display: "flex",
    flexDirection: "row",
    gap: "40px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "20px",
    },
  },
  footerItemLeft: {
    backgroundColor: "#131313",
    color: "white",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      gap: "20px",
    },
  },
  footerItemRight: {
    backgroundColor: "#131313",
    color: "white",
    display: "flex",
    flexDirection: "row",
    gap: "40px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      textAlign: "left",
      gap: "20px",
    },
  },
  footerP: {
    fontSize: "12px",
    marginBottom: "7px",
    marginTop: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
      marginBottom: 0,
      marginTop: 0,
      flex: 1,
      display: "flex",
      alignItems: "flex-start",
    },
  },
  complianceLink: {
    fontSize: "16px",
    color: "#FFFFFF",
    marginTop: "20px",
    textDecoration: "underline",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
      marginTop: 0,
      textAlign: "left",
    },
  },
  footerItemBottom: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "8px 0",
    gap: "6px",
  },
  followUsSection: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      alignItems: "flex-start",
      gap: "20px",
      marginTop: 0,
    },
  },
  followUsItems: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      gap: "8px",
      flex: "0 0 auto",
    },
  },
  footerHelp: {
    backgroundColor: "#131313",
    color: "white",
    display: "flex",
    justifyContent: "center",
    borderTop: "1px solid #1F1F1F",
    paddingTop: "15px",
    paddingBottom: "15px",
    alignItems: "center",
    textAlign: "center",
    fontSize: "12px",
    marginTop: "20px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },

  link: {
    color: "#f06ec4",
    textDecoration: "none",
    transition: "color 0.2s ease",
    "&:visited": {
      color: "#f06ec4", // prevent default purple
    },
    "&:hover, &:focus": {
      color: "#ffffff",
      textDecoration: "underline",
    },
    "&:focus-visible": {
      outline: "2px solid #ff69b4",
      outlineOffset: 2,
      borderRadius: 4,
    },
  },
  complianceBadges: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: "4px 0",
    marginLeft: 0,
    marginRight: 0,
    [theme.breakpoints.down("sm")]: {
      gap: 4,
    },
  },
  badgeLink: {
    display: "inline-flex",
    lineHeight: 0,
    "&:focus-visible": {
      outline: "2px solid #ff69b4",
      outlineOffset: 2,
      borderRadius: 6,
    },
  },
  xIconLink: {
    display: "inline-flex",
    lineHeight: 0,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    "&:focus-visible": {
      outline: "2px solid #ff69b4",
      outlineOffset: 2,
      borderRadius: 6,
    },
  },
  badgeImg: {
    display: "block",
    borderRadius: 4,
    width: "64px",
    height: "32px",
    [theme.breakpoints.down("sm")]: {
      width: "40px",
      height: "20px",
    },
  },
  mobileHeaderRow: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 0,
      marginBottom: 0,
      minWidth: "fit-content",
    },
  },
  mobileFollowUsWrapper: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px",
      minWidth: "fit-content",
    },
  },
  mobileFollowUsHeader: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      backgroundColor: "#131313",
      color: "white",
      fontSize: "13px",
      fontWeight: "bold",
      marginBottom: 0,
      marginTop: 0,
      lineHeight: "1.2",
    },
  },
  mobileXIconLink: {
    display: "none",
    lineHeight: 0,
    [theme.breakpoints.down("sm")]: {
      display: "inline-flex",
    },
    "&:focus-visible": {
      outline: "2px solid #ff69b4",
      outlineOffset: 2,
      borderRadius: 6,
    },
  },
  desktopFollowUsHeader: {
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobileCookieReferralWrapper: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px",
      minWidth: "fit-content",
      marginBottom: 0,
      paddingBottom: 0,
    },
  },
  mobileCookieSettingsLink: {
    display: "none",
    textDecoration: "none",
    transition: "color 0.2s ease",
    fontSize: "14px",
    fontWeight: 400,
    "&:visited": {
      color: "#FFFFFFCC",
    },
    "&:hover, &:focus": {
      color: "#FFFFFF",
      textDecoration: "underline",
    },
    "&:focus-visible": {
      outline: "2px solid #ff69b4",
      outlineOffset: 2,
      borderRadius: 4,
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
      marginTop: 0,
      marginBottom: 0,
      textAlign: "left",
    },
  },
  desktopCookieReferralLinks: {
    display: "flex",
    flexDirection: "column",
    marginTop: "40px",
    marginBottom: "40px",
    gap: "12px",
    [theme.breakpoints.down("sm")]: {
      display: "none !important",
    },
  },
  mobileReferralProgramLink: {
    display: "none",
    textDecoration: "none",
    transition: "color 0.2s ease",
    fontSize: "14px",
    fontWeight: 400,
    textAlign: "left",
    "&:visited": {
      color: "#FFFFFFCC",
    },
    "&:hover, &:focus": {
      color: "#FFFFFF",
      textDecoration: "underline",
    },
    "&:focus-visible": {
      outline: "2px solid #ff69b4",
      outlineOffset: 2,
      borderRadius: 4,
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
      marginBottom: 0,
    },
  },
}));

export default useFooterStyle;
